export type QueryCoordinates = {
  lat?: number
  lng?: number
  zoom?: number
}

export function getCoordinatesFromQueryParams(query: string | undefined): QueryCoordinates {
  if (!query)
    return {
      zoom: 4,
      lat: 0,
      lng: 0
    }
  const coordinates: { lat?: number; lng?: number } = {}
  const queryArray = query.split('?')[1].split('&')
  queryArray.forEach((query) => {
    const [key, value] = query.split('=')
    if (key === 'center') {
      const [lat, lng] = value.split(',')
      coordinates.lat = parseFloat(lat)
      coordinates.lng = parseFloat(lng)
      return
    }
    coordinates[key] = parseFloat(value)
  })
  return coordinates
}

export function getIdFromQuery(query: string, key: string) {
  if (!query) return null
  const queryArray = query.split('?')[1].split('&')
  const id = queryArray.find((query) => query.split('=')[0] === key)
  return id ? id.split('=')[1] : null
}

export function getPropertyFromQuery(query: string, key: string) {
  if (!query) return null
  const queryArray = query.split('?')[1].split('&')
  const property = queryArray.find((query) => query.split('=')[0] === key)
  return property ? property.split('=')[1] : null
}
